<script>
  import { Graphic, Section, Polygon, PolygonLayer } from '@snlab/florence'
  import Legend from './Legend.svelte'
  import InfoBox from './InfoBox.svelte'

  export let height
  export let width
  export let baseColor
  export let fillColors
  export let colorScale
  export let opacity = 1
  export let geoScale
  export let backgroundGeom
  export let geometry
  export let type
  export let data
  export let colName
  export let hover = false
  export let top3
  export let comp1Label
  export let comp2Label

  let hoverHex
</script>

<Graphic {height} {width}>
  <Section {...geoScale} flipY>
    <PolygonLayer geometry={backgroundGeom} fill={baseColor} />
    {#if hover}
      <PolygonLayer
        onMouseover={({ key }) => {
          hoverHex = key
        }}
        onMouseout={() => {
          hoverHex = undefined
        }}
        {geometry}
        {opacity}
        fill={fillColors} />
    {:else}
      <PolygonLayer {geometry} {opacity} fill={fillColors} />
    {/if}

    <PolygonLayer
      geometry={backgroundGeom}
      fill="none"
      stroke={'#C8C8C8'}
      strokeWidth={0.5} />
  </Section>
  {#if hover}
    <InfoBox
      {height}
      {width}
      active={data.row(hoverHex)[colName]}
      top3={top3[data.row(hoverHex)['hex']]} />
  {/if}
  {#if type === 'orComparison'}
    <Legend {height} {width} {colorScale} {type} leftLabel={comp2Label} rightLabel={comp1Label} />
  {:else}
    <Legend {height} {width} {colorScale} {type} />
  {/if}
</Graphic>
